module.exports = __webpack_public_path__ + "img/zhanjia.5884a335.jpg";